@if (!isSelectable) {
  <mat-list color="primary">
    @for (member of members; track trackById($index, member)) {
      <mat-list-item [ngClass]="{ titular: member.owner === true }">
        @if (member.image) {
          <img matListItemAvatar [src]="member.image" />
        } @else {
          <mat-icon matListItemIcon svgIcon="user" [attr.owner]="member.owner === true"> </mat-icon>
        }

        <p matListItemTitle>
          {{ member.name }}
        </p>
      </mat-list-item>
    }
  </mat-list>
} @else {
  <mat-selection-list
    color="primary"
    [multiple]="false"
    [hideSingleSelectionIndicator]="true"
    (selectionChange)="selectionChange($event)"
    #membersList
    [ngClass]="{ hidden: loading }"
  >
    @for (member of members; track trackById($index, member)) {
      <mat-list-option [value]="member" [selected]="selectedMember?.id === member.id">
        @if (member.image) {
          <img matListItemAvatar [src]="member.image" />
        } @else {
          <mat-icon matListItemIcon svgIcon="user"></mat-icon>
        }

        <p matListItemTitle>
          {{ member.name }}
        </p>
      </mat-list-option>
    }
  </mat-selection-list>
}
